import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import OfferService from '@iso/services/SettingsService/OfferService';

function* viewOffer({ id }) {
    try {
        const response = yield call(OfferService.getOne, id);
        yield put(actions.viewOfferSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewOfferFailed(extractError(error)));
    }
}

function* watchViewOffer() {
    yield takeEvery(
        types.REQUEST_VIEW_OFFER,
        viewOffer,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewOffer),
    ]);
}

export default viewSaga;
